import axios from "axios";
import { useQuery } from "react-query";

export const useGetSingleMetric = ({
  contentType,
  field,
  statFunction,
  activeFilters = [],
  findQuery,
  queryOptions = {},
  vizCardId
}) => {
  const body = {
    contentType,
    field,
    statFunction,
    findQuery,
    activeFilters
  };

  const endpoint = `/api/insightMatrix/getSingleMetric`;

  return useQuery({
    queryKey: ["useGetSingleMetric", vizCardId, body],
    queryFn: () =>
      axios
        .post(endpoint, body, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((data) => data.data),
    ...queryOptions,
  });
};
